export * from './featureFlags'
export const NUMBER_OF_RECOMMENDATIONS = 9
